import React, { useEffect } from "react";
import canvasConfetti from "canvas-confetti";

const tenSeconds = 10 * 1000;
const animationEnd = Date.now() + tenSeconds;

const indigo = "#4700D1";
const violet = "#C0A8FF";
const brightPurple = "#AC2FD1";
const colors = [violet, indigo, brightPurple];

const defaults = {
  startVelocity: 20,
  spread: 360,
  ticks: 60,
  colors,
  disableForReducedMotion: true,
  resize: true,
};

export function Confetti() {
  useConfetti();

  return <></>;
}

function useConfetti() {
  useEffect(() => {
    const interval = setInterval(function () {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 50 * (timeLeft / tenSeconds);
      canvasConfetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
        })
      );
      canvasConfetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
        })
      );
    }, 250);

    return () => {
      canvasConfetti.reset();
      clearInterval(interval);
    };
  }, []);
}

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}
